import React from 'react'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Caption from 'LuxKit/Typography/Caption'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import MarkdownRender from 'LuxKit/MarkdownRender'
import { insuranceBokingProtectionCancellationReasons } from 'constants/insurance'

const CancellationReasonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem(24)};
  & > * {
    margin-bottom: ${rem(4)};
    &:last-child {
      margin-bottom: 0;
    }
  }

  ${mediaQueryUp.tablet} {
    display: block;
    gap: ${rem(20)};
    max-height: ${rem(248)};
    max-width: ${rem(202)};
    column-count: auto;
    column-width: ${rem(200)};
    column-gap: ${rem(20)};
    align-self: stretch;
    margin-bottom: ${rem(16)};
  }

`

const DisclaimerCaption = styled(Caption)`
  max-width: ${rem(500)};
`

interface Props {
  quote?: App.InsuranceQuote
}

function CFMRUnforseenEventsModalContent(props: Props) {
  const { quote } = props

  return (
    <Group direction="vertical">
      <CancellationReasonsContainer>
        {insuranceBokingProtectionCancellationReasons.map((reason: string, index: number) => (
          <BodyTextBlock variant="medium" key={index} startIcon={<LineCheckIcon colour="highlight-secondary" />}>
            {reason}
          </BodyTextBlock>
        ))}
      </CancellationReasonsContainer>
      <DisclaimerCaption variant="medium" colour="neutral-one">
        <MarkdownRender content={quote?.disclaimer ?? ''} fontSize="small" />
      </DisclaimerCaption>
    </Group>
  )
}

export default CFMRUnforseenEventsModalContent
